"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _textField = _interopRequireDefault(require("./text-field"));

var _attach = _interopRequireDefault(require("../attach"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var URLField = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2.default)(URLField, _React$PureComponent);

  var _super = _createSuper(URLField);

  function URLField() {
    (0, _classCallCheck2.default)(this, URLField);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(URLField, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          component = _this$props.component,
          value = _this$props.value,
          editable = _this$props.editable,
          useDisplayValue = _this$props.useDisplayValue,
          newWindow = _this$props.newWindow;
      var displayValue = null; // Note: editable & useDisplayValue are checked to avoid unnecessary rendering

      if ((!editable || useDisplayValue) && value) {
        var href = value;

        if (href.indexOf('http') !== 0) {
          href = 'http://' + href;
        }

        displayValue = /*#__PURE__*/_react.default.createElement("a", {
          href: href,
          target: newWindow ? '_blank' : '_self'
        }, value);
      }

      return /*#__PURE__*/_react.default.createElement(_textField.default, {
        component: component,
        displayValue: displayValue
      });
    }
  }]);
  return URLField;
}(_react.default.PureComponent);

var _default = (0, _attach.default)(['value', 'editable', 'useDisplayValue', 'newWindow'])(URLField);

exports.default = _default;